module.exports = __webpack_public_path__ + "img/hzLogo1.126fc3d2.png";